import React, {useEffect, useRef, useState} from "react";
import "./Header.scss";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {getAccountAsync, selectAccountName, selectAccountStatus} from "./accountSlice";
import {useClickOutside, useScrollOutside} from "../../infrastructure/hooks";
import {useAuth} from "react-oidc-context";
import {oidcUserKey} from "../../session-storage/session-storage";
import {isIdle} from "../../infrastructure/status";
import {applicationRootPath} from "../../infrastructure/config";

export const Header = () => {
  const accountName = useAppSelector(selectAccountName);
  const accountStatus = useAppSelector(selectAccountStatus);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAccountAsync());
  }, [dispatch]);

  const [showMenu, setShowMenu] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);

  useClickOutside(dropdownRef, () => {
    setShowMenu(false);
  });
  useScrollOutside(dropdownRef, () => {
    setShowMenu(false);
  });

  const auth = useAuth();
  const logout = () => {
    sessionStorage.removeItem(oidcUserKey);
    auth.signoutRedirect({id_token_hint: auth.user.id_token});
  };

  return (
    <header className="o-header light">
      <nav className="o-header-left">
        <a href={applicationRootPath} className="logo dnv-logo" target="_self"></a>
      </nav>
      <div className="o-header-right">
        <nav className="o-header-name">
          <a href={applicationRootPath} className="o-header-product">
            Synergi Life Mobile Service Admin Panel
          </a>
        </nav>
        <nav className="o-header-actions">
          <ul className="actions-group">
            <li ref={dropdownRef} className="o-header-item no-hover has-children">
              <a
                aria-haspopup="true"
                aria-expanded={showMenu}
                target="_self"
                href="#"
                className="o-header-action-button"
                data-toggle="header-user-dropdown-menu"
                id="header-user-dropdown"
                onClick={() => {
                  setShowMenu(!showMenu);
                }}>
                <i tabIndex={0} className="fad fa-user-circle header-user-icon"></i>
              </a>
              <ul
                tabIndex={-1}
                id="header-user-dropdown-menu"
                className={`o-header-dropdown-menu child-menu ${showMenu ? "show" : ""}`}
                aria-labelledby="header-user-dropdown">
                {isIdle(accountStatus) && !!accountName && (
                  <li className="o-header-item">
                    <h4 className="header-user-row">
                      <i className="fad fa-user-circle color-sea-blue header-user-icon"></i>
                      <div className="header-user-text">{accountName}</div>
                    </h4>
                  </li>
                )}
                <li className="o-header-item">
                  <a href="#" className="o-header-link" onClick={logout}>
                    Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};
